import animateOnScroll from '../animateOnScroll';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  let windowSize = window.innerWidth;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,

    cardWidgetLoaded: function (data) {
      const seoWidgetData = data.items;

      if (seoWidgetData.length < 1) {
        $(`.tier-3-container .inner-container-tier-a`).remove();
        $('.tier-3-container').addClass('no-seo-loaded');
      } else {
        createCustomSeo(seoWidgetData[0]);
      }
    },
  });
  function createCustomSeo(widgetData) {
    const { Title } = widgetData;

    const imageContent = `
      <img class="seo-image" 
          alt="${Title}" 
          src="${`${FULLCLIENTTHEMEPATH}images/seo-graph.png`}"
          data-aos= "fade-in"
          data-aos-delay= ${windowSize <= 1050 ? '800' : '1600'}
          data-aos-easing= "ease-in-out"
          data-aos-duration= "800"
          data-aos-once= "true"
          data-aos-offset= 100,
      />
    `;

    $(`#${widgetName} .buttonwrap`).remove();
    $(`#${widgetName} .card-widget-title`).replaceWith(
      `<h2 class="card-widget-title">${Title}</h2>`,
    );
    $(`#${widgetName}`).append(imageContent);

    $(`#${widgetName} .card-widget-item`).attr({
      'data-aos': 'fade-right',
      'data-aos-delay': '400',
      'data-aos-easing': 'ease-in-out',
      'data-aos-duration': '800',
      'data-aos-once': 'true',
    });

    animateOnScroll('#seoWidget', '#seoWidget', 'animate-abstract');
  }
}
